import { render, staticRenderFns } from "./CanteenPage.vue?vue&type=template&id=063754e2&"
import script from "./CanteenPage.vue?vue&type=script&lang=js&"
export * from "./CanteenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports